import React, { useCallback, useEffect, useState } from "react";
import { Box, Grid, Stack } from "@mui/material";
import "./App.scss";
import Navbar from "./components/Navbar/Navbar";
import Sidebar from "./components/Sidebar/Sidebar";
import AppSwitch from "./routes/routes";
import { useDispatch, useSelector } from "react-redux";

import { validateAuthToken } from "./store/security";
import Loader from "./components/Loader/Loader";
import { Toaster } from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
import { setNavigate } from "./utils/utils";
import NetworkError from "./features/NetworkError/NetworkError";
const { LOCAL_STORAGE_KEYS } = require("./constants/constants");

const App = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isUserLoggedIn, loading } = useSelector((state) => state?.security);
  const [componentLoading, setComponentLoading] = useState(false);
  const [collapsed, setCollapsed] = useState(false);
  setNavigate(navigate);

  const location = useLocation();
  const isNetworkError = location?.state?.isNetworkError;
  const pattern = /^\/evaluations\/([^\/]+)$/;
  const urlmatch = location.pathname.match(pattern);

  // Refresh the page on switching user
  useEffect(() => {
    if (isNetworkError) {
      navigate("/", { replace: true });
    }

    const handleStorageChange = (event) => {
      if (
        event.key === LOCAL_STORAGE_KEYS.BOOTCAMP_SWITCH_USER ||
        event.key === LOCAL_STORAGE_KEYS.USER_LOGGED_IN ||
        (event.key === LOCAL_STORAGE_KEYS.USER_LOGOUT &&
          localStorage.getItem(LOCAL_STORAGE_KEYS.USER_LOGOUT) === "true")
      ) {
        window.location.href = "/";
      }
    };

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  useEffect(() => {
    (async () => {
      setComponentLoading(true);
      await dispatch(validateAuthToken());
      setComponentLoading(false);
    })();
  }, [dispatch]);

  // Helper function to get sidebar width
  const getSidebarWidth = useCallback(() => {
    if (urlmatch) {
      return 0;
    }
    return collapsed ? "5.6rem" : "13rem";
  }, [collapsed, urlmatch]);

  useEffect(
    () =>
      document.documentElement.style.setProperty(
        "--sidebar-width",
        getSidebarWidth()
      ),
    [getSidebarWidth]
  );

  // Helper function to render main content
  const renderMainContent = () => {
    if (!isUserLoggedIn) {
      return <AppSwitch isUserLoggedIn={isUserLoggedIn} />;
    }
    if (isNetworkError) {
      return <NetworkError />;
    }
    return (
      <Box className="home-layout">
        <Toaster />
        <Navbar />
        <Stack direction="row" className="home-container">
          {loading && componentLoading ? (
            <Box className="main-page-loader">
              <Loader />
            </Box>
          ) : (
            <>
              <Grid
                className="side-navigation"
                sx={{ display: { xs: "none", sm: "none", md: "block" } }}
              >
                {!urlmatch && (
                  <Sidebar collapsed={collapsed} setCollapsed={setCollapsed} />
                )}
              </Grid>
              <Grid className="main-page-container">
                <AppSwitch isUserLoggedIn={isUserLoggedIn} />
              </Grid>
            </>
          )}
        </Stack>
      </Box>
    );
  };

  return <>{renderMainContent()}</>;
};

export default App;
